module.exports = __webpack_public_path__ + "img/list2.10792aee.jpg";